export default "__VITE_ASSET__DXXmSuou__"